import { Checkbox, CheckboxGroup, Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { PenetrationDepthMeasuredBy } from '../../types';

let LayerBoundariesOptionsBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const reportPenetrationResistance = useSelector(
    pipe(createWorksheetSelector!('PenetrationResistanceCheck'), valueOrDefault(false))
  );

  const canShowGraduationsInterval = useSelector(
    pipe(
      createWorksheetSelector!('data.Preparation.PenetrationDepthMeasuredBy', false),
      (d) => d === PenetrationDepthMeasuredBy.GraduationsAtUniformIntervals
    )
  );

  let reportingOptions = [{ label: 'Penetration Resistance', name: 'PenetrationResistanceCheck' }];

  if (canShowGraduationsInterval)
    reportingOptions.push({
      label: 'Blows Per Graduation Interval',
      name: 'BlowsPerGraduationIntervalCheck',
    });

  return (
    <>
      <ListFieldSection>
        <Field input={<TextOutput />} name="StartDepth" />
        <Field input={<TextOutput />} name="FinalDepth" />
        <Field input={<TextOutput />} visible={reportPenetrationResistance} name="PenetrationResistance" />
        <Field input={<TextOutput />} name="DepthToMidpoint" />
      </ListFieldSection>
      <ListFieldSection>
        <Field input={<Checkbox />} name="JoinLayersOnChart" />
        <Field input={<TextOutput />} visible={canShowGraduationsInterval} name="BlowsPerGraduationInterval" />
      </ListFieldSection>
      <ListFieldSection heading="Report">
        <Field input={<CheckboxGroup />} options={reportingOptions} />
      </ListFieldSection>
    </>
  );
};
const LayerBoundariesOptions = withInjectedProps(LayerBoundariesOptionsBase);

export { LayerBoundariesOptions };
export default LayerBoundariesOptions;
